<template>
  <div>
    <!-- Modal licencia vencida -->
    <div class="modal fade" id="ModalLicenseExpired" tabindex="-1" aria-labelledby="licenseExpiredModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content license-expired-modal">
          <div class="modal-body">
            <div class="license-expired-modal__icon">
              <i class="fas fa-exclamation-circle"></i>
            </div>
            <h4 class="license-expired-modal__title">¡Tu licencia ha vencido!</h4>
            <p class="license-expired-modal__text">
              Tu licencia venció el <strong>{{ licenseCoverageLabel }}</strong>. Renuévala para seguir disfrutando de todos los beneficios de Mi Stock.
            </p>
            <div class="license-expired-modal__actions">
              <router-link :to="{ name: 'Payment' }" class="btn btn-danger btn-lg license-expired-modal__btn" @click="closeExpiredModal">
                <i class="fas fa-credit-card me-2"></i>Renovar ahora
              </router-link>
              <button class="btn btn-link text-secondary license-expired-modal__skip" @click="closeExpiredModal">
                Recordar más tarde
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="py-4 container-fluid dashboard-page">
    <div class="row">
      <div class="col-12">
        <div class="row">

          <div class="col-lg-12 col-md-12 col-12 mb-3" v-if="isFieldWorker" :class="$store.state.darkMode ? 'text-white' : 'text-dark'">
            <h2 class="mb-0">Bienvenido {{ user.name }}</h2>
            <p class="text-sm opacity-8 mb-0">Resumen de tus trabajos del mes</p>
          </div>

          <div class="col-lg-4 col-md-6 col-12" v-if="isFieldWorker">
            <card
              title="Trabajos del mes"
              :value="String(operarioStats.tasksCount)"
              percentage="Registrados en el periodo"
              iconClass="fas fa-tools"
              iconBackground="bg-gradient-info"
              directionReverse
            ></card>
          </div>

          <div class="col-lg-4 col-md-6 col-12" v-if="isFieldWorker">
            <card
              title="Ganancia pendiente"
              :value="formatMoney(operarioStats.pendingEarning)"
              :percentage="`${employeeCommissionPercent}% por cobrar al empleado`"
              iconClass="fas fa-clock"
              iconBackground="bg-gradient-warning"
              directionReverse
            ></card>
          </div>

          <div class="col-lg-4 col-md-6 col-12" v-if="isFieldWorker">
            <card
              title="Pagado al empleado"
              :value="formatMoney(operarioStats.paidEarning)"
              percentage="Total recibido en el mes"
              iconClass="fas fa-hand-holding-usd"
              iconBackground="bg-gradient-success"
              directionReverse
            ></card>
          </div>

          <div class="col-12 mt-4" v-if="isFieldWorker">
            <div class="card">
              <div class="card-header pb-0">
                <h6 class="mb-0">Últimos trabajos</h6>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Descripción</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tu ganancia</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="recentTasks.length === 0">
                        <td colspan="5" class="text-center text-sm text-secondary py-4">
                          No hay trabajos registrados este mes.
                        </td>
                      </tr>
                      <tr v-for="task in recentTasks" :key="task.id">
                        <td>
                          <p class="text-sm mb-0 px-3">{{ task.description }}</p>
                        </td>
                        <td class="align-middle text-center text-sm">{{ formatMoney(task.price) }}</td>
                        <td class="align-middle text-center text-sm">{{ formatMoney(employeeEarning(task)) }}</td>
                        <td class="align-middle text-center">
                          <span class="badge badge-sm" :class="taskStatusClass(task.status)">
                            {{ taskStatusLabel(task.status) }}
                          </span>
                        </td>
                        <td class="align-middle text-center text-sm">{{ formatTaskDate(task.task_date) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-12"  v-if="user.role==='1' || user.role==='2'">
            <router-link 
            :to="{ name: 'Users' }" 
            class="card-link"
            
          >
            <card
              :title="stats.users.title"
              :value="stats.users.value"
               :percentage="stats.users.percentage"
              :iconClass="stats.users.iconClass"
              :iconBackground="stats.users.iconBackground"
              directionReverse
            ></card>
          </router-link>
          </div>

          <div class="col-lg-4 col-md-6 col-12" v-if="user.role==='1'">
            <router-link :to="{ name: 'Payment' }" class="card-link text-decoration-none">
              <div class="mb-4 card" :class="licenseCardBorder">
                <div class="p-3 card-body">
                  <div class="d-flex flex-row-reverse justify-content-between">
                    <div>
                      <div class="text-center icon icon-shape border-radius-2xl" :class="licenseIconBg">
                        <i class="text-lg opacity-10 fa fa-id-card" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div>
                      <div class="numbers">
                        <p class="mb-0 text-sm text-uppercase font-weight-bold">Licencia</p>
                        <h5 class="font-weight-bolder" :class="licenseExpired ? 'text-danger' : getStatusColor(license.status)">{{ licenseStatusLabel }}</h5>
                        <span class="text-sm" :class="licenseExpired ? 'text-danger' : getStatusColor(license.status)">{{ licenseCoverageLabel }}</span>
                        <span v-if="licenseExpired" class="badge bg-gradient-danger text-white ms-2" style="font-size:0.68rem;vertical-align:middle;">
                          <i class="fas fa-times-circle me-1"></i>Licencia vencida
                        </span>
                        <span v-else-if="licenseExpiringSoon" class="badge bg-gradient-warning text-white ms-2" style="font-size:0.68rem;vertical-align:middle;">
                          <i class="fas fa-exclamation-triangle me-1"></i>¡Vence en {{ licenseDaysLeft }} día{{ licenseDaysLeft === 1 ? '' : 's' }}!
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-12 mt-4" v-if="user.role==='1' || user.role==='2'">
            <remissions-monthly-chart />
          </div>

          <div class="col-12 mt-4" v-if="user.role==='1' || user.role==='2'">
            <worker-tasks-by-user-chart />
          </div>

          <div class="col-12 mt-4" v-if="user.role==='1' || user.role==='2'">
            <oil-reminder-clients />
          </div>

          <!-- New metrics section - admin only -->
          <div class="col-12 mt-4" v-if="isAdmin">
            <div class="card">
              <div class="card-header pb-0">
                <div class="d-flex align-items-center flex-wrap gap-2">
                  <h6 class="mb-0">Métricas del Negocio</h6>
                  <input
                    v-if="metricsPeriod !== 'year'"
                    v-model="metricsDate"
                    type="date"
                    class="form-control form-control-sm"
                    style="width: auto;"
                    @change="fetchMetricsSummary"
                  />
                  <input
                    v-if="metricsPeriod === 'year'"
                    v-model="metricsYear"
                    type="number"
                    min="2020"
                    max="2099"
                    class="form-control form-control-sm"
                    style="width: 100px;"
                    @change="fetchMetricsSummary"
                  />
                  <span v-if="metricsSummary" class="text-sm text-secondary">{{ metricsSummary.range_label }}</span>
                  <div class="btn-group ms-auto" role="group">
                    <button
                      v-for="opt in metricsPeriodOptions"
                      :key="opt.value"
                      type="button"
                      class="btn btn-sm mb-0"
                      :class="metricsPeriod === opt.value ? 'btn-primary' : 'btn-outline-primary'"
                      @click="changeMetricsPeriod(opt.value)"
                    >
                      {{ opt.label }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row g-3">
                  <div
                    v-for="mc in metricsCards"
                    :key="mc.key"
                    class="col-12 col-sm-6 col-xl"
                  >
                    <div class="card border-0 shadow-sm h-100">
                      <div class="card-body p-3">
                        <div class="d-flex flex-row-reverse justify-content-between">
                          <div>
                            <div class="text-center icon icon-shape border-radius-2xl" :class="mc.iconBg">
                              <i class="text-lg opacity-10 ni" :class="mc.icon"></i>
                            </div>
                          </div>
                          <div>
                            <div class="numbers">
                              <p class="mb-0 text-sm text-uppercase font-weight-bold">{{ mc.title }}</p>
                              <h5 class="font-weight-bolder mb-0">{{ formatMetricValue(mc.key, mc.isCount) }}</h5>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center mt-2 pt-2 border-top">
                          <span class="text-xs font-weight-bold me-1" :class="metricVariationClass(mc.key)">
                            {{ metricVariationArrow(mc.key) }} {{ Math.abs(metricsSummary.metrics[mc.key].variation_percent) }}%
                          </span>
                          <span class="text-xs text-secondary">vs {{ formatMetricPrevious(mc.key, mc.isCount) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mt-4" v-if="isAdmin">
            <div class="card">
              <div class="card-header pb-0">
                <h6 class="mb-0">Desglose Semanal</h6>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Semana</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Repuestos</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Mano de Obra</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Motos</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Egresos</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ganancia</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Variación</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="week in metricsWeekly" :key="week.week">
                        <td class="text-sm">{{ week.label }}</td>
                        <td class="text-center text-sm">{{ formatMoney(week.parts_revenue) }}</td>
                        <td class="text-center text-sm">{{ formatMoney(week.labor_revenue) }}</td>
                        <td class="text-center text-sm">{{ week.motorcycles_count }}</td>
                        <td class="text-center text-sm text-danger">{{ formatMoney(week.money_outflow) }}</td>
                        <td class="text-center text-sm font-weight-bold text-success">{{ formatMoney(week.profit) }}</td>
                        <td class="text-center text-sm">
                          <span :class="week.variation_profit >= 0 ? 'text-success' : 'text-danger'">
                            {{ week.variation_profit >= 0 ? '↑' : '↓' }} {{ Math.abs(week.variation_profit) }}%
                          </span>
                        </td>
                      </tr>
                      <tr v-if="!metricsWeekly || metricsWeekly.length === 0">
                        <td colspan="7" class="text-center text-xxs">No hay registros disponibles</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- New extended metrics section - admin only -->
          <div class="col-12 mt-4" v-if="isAdmin">
            <h5 class="mb-3" :class="$store.state.darkMode ? 'text-white' : 'text-dark'">Métricas Detalladas</h5>
          </div>

          <div class="col-12 mt-2" v-if="isAdmin">
            <parts-balance />
          </div>

          <div class="col-12 mt-4" v-if="isAdmin">
            <technician-tracking />
          </div>

          <div class="col-12 mt-4" v-if="isAdmin">
            <customer-repurchase />
          </div>

          <div class="col-12 mt-4" v-if="isAdmin">
            <oil-change-reminders />
          </div>

          <div class="col-12 mt-4" v-if="isAdmin">
            <inventory-tracking />
          </div>

          <div class="col-12 mt-4" v-if="isAdmin">
            <labor-by-service />
          </div>

        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
import RemissionsMonthlyChart from "@/examples/Charts/RemissionsMonthlyChart.vue";
import WorkerTasksByUserChart from "@/examples/Charts/WorkerTasksByUserChart.vue";
import workerTasksService from "@/services/workerTasks.service";
import { formatDateOnly } from "@/helpers/dateFormat";
import { Modal } from 'bootstrap';
import { mapGetters } from "vuex";
import { colombiaTodayString } from '@/helpers/dateFormat';
import TechnicianTracking from "@/components/metrics/TechnicianTracking.vue";
import OilReminderClients from "@/components/OilReminderClients.vue";
import CustomerRepurchase from "@/components/metrics/CustomerRepurchase.vue";
import OilChangeReminders from "@/components/metrics/OilChangeReminders.vue";
import InventoryTracking from "@/components/metrics/InventoryTracking.vue";
import PartsBalance from "@/components/metrics/PartsBalance.vue";
import LaborByService from "@/components/metrics/LaborByService.vue";

export default {
  name: "dashboard-default",
  data() {
    return {
      stats: {
        projects: {
          title: "Citas programadas hoy",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-folder-17",
          detail: "since yesterday",
          iconBackground: "bg-gradient-info",
        },
        users: {
          title: "Usuarios",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-user-run",
          iconBackground: "bg-gradient-danger",
          detail: "since last week",
        },
      },
      user:{},
      undelivered:[],
      unvalidated:[],
      production:[],
      license:{},
      bsExpiredModal: null,
      operarioStats: {
        tasksCount: 0,
        pendingEarning: 0,
        paidEarning: 0,
      },
      recentTasks: [],
      metricsSummary: null,
      metricsWeekly: [],
      metricsPeriod: 'month',
      metricsDate: colombiaTodayString(),
      metricsYear: new Date().getFullYear(),
      metricsPeriodOptions: [
        { value: 'day', label: 'Día' },
        { value: 'week', label: 'Semana' },
        { value: 'month', label: 'Mes' },
        { value: 'year', label: 'Año' },
      ],
      metricsCards: [
        { key: 'parts_revenue', title: 'Entradas Repuestos', icon: 'ni-box-2', iconBg: 'bg-gradient-info', isCount: false },
        { key: 'labor_revenue', title: 'Entradas Mano de Obra', icon: 'ni-hat-3', iconBg: 'bg-gradient-warning', isCount: false },
        { key: 'motorcycles_count', title: 'Motos Ingresadas', icon: 'ni-delivery-fast', iconBg: 'bg-gradient-primary', isCount: true },
        { key: 'money_outflow', title: 'Salidas de Dinero', icon: 'ni-money-coins', iconBg: 'bg-gradient-danger', isCount: false },
        { key: 'profit', title: 'Ganancia del Periodo', icon: 'ni-chart-pie-35', iconBg: 'bg-gradient-success', isCount: false },
      ],
    };
  },
  components: {
    Card,
    RemissionsMonthlyChart,
    WorkerTasksByUserChart,
    OilReminderClients,
    TechnicianTracking,
    CustomerRepurchase,
    OilChangeReminders,
    InventoryTracking,
    PartsBalance,
    LaborByService,
  },
  computed: {
    userRole() {
      return String(this.user?.role ?? '');
    },
    isFieldWorker() {
      return this.userRole === '3' || this.userRole === '6';
    },
    isAdminOrSupervisor() {
      return this.userRole === '1' || this.userRole === '2';
    },
    isAdmin() {
      return this.userRole === '1';
    },
    licenseStatusLabel() {
      if (this.licenseExpired) return 'Vencida';
      const status = this.license?.status;
      if (status === 'paid') return 'Pagado';
      if (status === 'pending') return 'Pendiente';
      if (status === 'rejected') return 'Rechazado';
      if (status === 'voided') return 'Anulado';
      if (!status) return 'Sin licencia';
      return 'Validando...';
    },
    licenseCoverageLabel() {
      const formatted = formatDateOnly(this.license?.coverage_month);
      return formatted ?? 'Renovar ahora';
    },
    licenseDaysLeft() {
      const raw = this.license?.coverage_month;
      if (!raw) return null;
      const datePart = String(raw).split('T')[0];
      const match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return null;
      const expiry = new Date(`${match[1]}-${match[2]}-${match[3]}T00:00:00`);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const diff = Math.floor((expiry - today) / (1000 * 60 * 60 * 24));
      return diff;
    },
    licenseExpiringSoon() {
      const days = this.licenseDaysLeft;
      return days !== null && days >= 0 && days <= 3;
    },
    licenseExpired() {
      const days = this.licenseDaysLeft;
      return days !== null && days < 0;
    },
    licenseCardBorder() {
      if (this.licenseExpired) return 'border border-danger border-2';
      if (this.licenseExpiringSoon) return 'border border-warning border-2';
      return '';
    },
    licenseIconBg() {
      if (this.licenseExpired) return 'bg-gradient-danger';
      if (this.licenseExpiringSoon) return 'bg-gradient-warning';
      return 'bg-gradient-dark';
    },
    ...mapGetters('settings', ['employeeCommissionPercent', 'employeeCommissionRate']),
  },
  methods: {
      async fetchAnalytics() {
        await this.$store.dispatch('analitycs/getCards'); 
        this.stats = this.$store.state.analitycs.cards;
      },
      async fetchUndelivered() {
        let datos = await this.$store.dispatch('analitycs/getUndelivered'); 
        this.undelivered = datos.data;
      },
      async fetchUnvalidated() {
        let datos = await this.$store.dispatch('analitycs/getUnvalidate'); 
        this.unvalidated = datos.data;
      },
      async fetchProduction() {
        let datos = await this.$store.dispatch('analitycs/getProduction'); 
        this.production = datos.data;
      },
      async fetchLicense() {
        const license = await this.$store.dispatch('payments/get');
        this.license = license || { status: null, coverage_month: null };
        if (this.licenseExpired) {
          this.$nextTick(() => {
            const el = document.getElementById('ModalLicenseExpired');
            this.bsExpiredModal = new Modal(el);
            this.bsExpiredModal.show();
          });
        }
      },
      closeExpiredModal() {
        if (this.bsExpiredModal) {
          this.bsExpiredModal.hide();
        }
      },
      getStatusColor(status) {
        switch (status) {
          case 'paid':
            return 'text-success';
          case 'pending':
            return 'text-warning';
          case 'rejected':
            return 'text-danger';
          case 'voided':
            return 'text-muted';
          case null:
          case undefined:
          case '':
            return 'text-danger';
          default:
            return 'text-secondary';
        }
      },
      monthRange() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const lastDay = new Date(year, now.getMonth() + 1, 0).getDate();
        return {
          start_date: `${year}-${month}-01`,
          end_date: `${year}-${month}-${String(lastDay).padStart(2, "0")}`,
        };
      },
      employeeEarning(task) {
        if (task?.employee_earning != null) {
          return parseFloat(task.employee_earning) || 0;
        }
        return Math.round((parseFloat(task?.price) || 0) * this.employeeCommissionRate * 100) / 100;
      },
      employeeBalance(task) {
        const earning = this.employeeEarning(task);
        const paid = parseFloat(task?.employee_paid ?? 0) || 0;
        return Math.max(0, Math.round((earning - paid) * 100) / 100);
      },
      formatMoney(value) {
        return Number(value || 0).toLocaleString("es-CO", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      },
      formatTaskDate(value) {
        return formatDateOnly(value) || "—";
      },
      taskStatusLabel(status) {
        if (status === "paid") return "Pagado";
        if (status === "partial") return "Parcial";
        return "Pendiente";
      },
      taskStatusClass(status) {
        if (status === "paid") return "bg-gradient-success";
        if (status === "partial") return "bg-gradient-info";
        return "bg-gradient-warning";
      },
      async fetchMetricsSummary() {
        if (!this.isAdmin) return;
        try {
          const params = { period: this.metricsPeriod };
          if (this.metricsPeriod !== 'year' && this.metricsDate) {
            params.date = this.metricsDate;
          }
          if (this.metricsPeriod === 'year') {
            params.date = String(this.metricsYear);
          }
          const response = await this.$store.dispatch('metrics/getSummary', params);
          this.metricsSummary = response.data;
        } catch (error) {
          console.error('Error loading metrics summary:', error);
        }
      },
      async fetchMetricsWeekly() {
        if (!this.isAdmin) return;
        try {
          const now = new Date();
          const month = now.getMonth() + 1;
          const year = now.getFullYear();
          const response = await this.$store.dispatch('metrics/getWeeklyBreakdown', { month, year });
          this.metricsWeekly = response.data?.weeks ?? [];
        } catch (error) {
          console.error('Error loading weekly breakdown:', error);
        }
      },
      changeMetricsPeriod(period) {
        this.metricsPeriod = period;
        this.fetchMetricsSummary();
      },
      formatMetricValue(key, isCount) {
        if (!this.metricsSummary) return '—';
        const val = this.metricsSummary.metrics[key]?.current ?? 0;
        if (isCount) return String(Math.round(val));
        return this.formatMoney(val);
      },
      formatMetricPrevious(key, isCount) {
        if (!this.metricsSummary) return '—';
        const val = this.metricsSummary.metrics[key]?.previous ?? 0;
        if (isCount) return String(Math.round(val));
        return this.formatMoney(val);
      },
      metricVariationClass(key) {
        if (!this.metricsSummary) return 'text-secondary';
        const pct = this.metricsSummary.metrics[key]?.variation_percent ?? 0;
        return pct >= 0 ? 'text-success' : 'text-danger';
      },
      metricVariationArrow(key) {
        if (!this.metricsSummary) return '';
        const pct = this.metricsSummary.metrics[key]?.variation_percent ?? 0;
        return pct >= 0 ? '↑' : '↓';
      },
      async fetchOperarioMetrics() {
        if (!this.user?.id) {
          return;
        }

        try {
          const range = this.monthRange();
          const response = await workerTasksService.getAll({
            page: "all",
            user_id: this.user.id,
            start_date: range.start_date,
            end_date: range.end_date,
          });
          const tasks = Array.isArray(response.data)
            ? response.data
            : response.data?.data || [];

          this.operarioStats.tasksCount = tasks.length;
          this.operarioStats.pendingEarning = tasks
            .filter((task) => task.status === "pending" || task.status === "partial")
            .reduce((total, task) => total + this.employeeBalance(task), 0);
          this.operarioStats.paidEarning = tasks.reduce(
            (total, task) => total + (parseFloat(task.employee_paid ?? 0) || 0),
            0
          );

          this.recentTasks = [...tasks]
            .sort((a, b) => String(b.task_date || "").localeCompare(String(a.task_date || "")))
            .slice(0, 8);
        } catch (error) {
          console.error("Error loading operario metrics:", error);
        }
      },
  },
  async mounted() {

    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      this.user = {
        ...user,
        role: String(user.role ?? ''),
      };
    }

    if(this.isAdminOrSupervisor){
      this.fetchAnalytics(); 
      this.fetchUndelivered(); 
      this.fetchUnvalidated(); 
      this.fetchProduction(); 
      this.fetchLicense();
    }

    if (this.isFieldWorker) {
      try {
        await this.$store.dispatch('settings/get');
      } catch (error) {
        console.error('Error loading settings for dashboard:', error);
      }
      this.fetchOperarioMetrics();
    }

    if (this.isAdmin) {
      this.fetchMetricsSummary();
      this.fetchMetricsWeekly();
    }
  },
};
</script>

<style scoped>
.btn-group .btn {
  margin-bottom: 0;
}

.dashboard-page {
  position: relative;
  z-index: 0;
  max-width: 100%;
  overflow-x: hidden;
}

.dashboard-page :deep(.dashboard-chart-card) {
  position: relative;
  z-index: 0;
}

.license-expired-modal {
  border-radius: 1.25rem;
  text-align: center;
  overflow: hidden;
}

.license-expired-modal .modal-body {
  padding: 2.5rem 2rem;
}

.license-expired-modal__icon {
  font-size: 3.5rem;
  color: #dc3545;
  margin-bottom: 1rem;
}

.license-expired-modal__title {
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 0.75rem;
}

.license-expired-modal__text {
  color: #555;
  font-size: 0.95rem;
  margin-bottom: 1.75rem;
  line-height: 1.6;
}

.license-expired-modal__actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.license-expired-modal__btn {
  border-radius: 999px;
  padding: 0.75rem 2rem;
  font-weight: 700;
  width: 100%;
}

.license-expired-modal__skip {
  font-size: 0.85rem;
  text-decoration: none;
}

</style>
